import { isMobile } from "./isMobile";

jQuery(function ($) {
  $(window).on("load resize", function () {
    if (isMobile()) {
      $(".colspan-2").attr("colspan", 2);
    } else {
      $(".colspan-2").removeAttr("colspan");
    }
  });
});
